export var SrciCardTypeEnumsObj = {
    CREDIT: "CREDIT",
    DEBIT: "DEBIT",
    PREPAID: "PREPAID",
    COMBO: "COMBO",
    FLEX: "FLEX",
};
